module.exports = __webpack_public_path__ + "img/cjcl8.fa304cc6.png";